import { render, staticRenderFns } from "./GiftCardComponent.vue?vue&type=template&id=4d4cd08e&scoped=true"
import script from "./GiftCardComponent.vue?vue&type=script&lang=js"
export * from "./GiftCardComponent.vue?vue&type=script&lang=js"
import style0 from "./GiftCardComponent.vue?vue&type=style&index=0&id=4d4cd08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4cd08e",
  null
  
)

export default component.exports